"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePage = exports.default = exports.PageProvider = exports.PAGES = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PAGES = exports.PAGES = /*#__PURE__*/function (PAGES) {
  PAGES["loggedOutPage"] = "loggedOutPage";
  PAGES["icertisAuthPage"] = "icertisAuthPage";
  PAGES["icertisCallbackPage"] = "icertisCallbackPage";
  PAGES["documentReviewPage"] = "documentReviewPage";
  PAGES["ruleDetailsPage"] = "ruleDetailsPage";
  PAGES["submitDocumentPage"] = "submitDocumentPage";
  PAGES["reviewConfirmationPage"] = "reviewConfirmationPage";
  PAGES["libraryPage"] = "libraryPage";
  PAGES["promptPage"] = "promptPage";
  PAGES["clausePage"] = "clausePage";
  PAGES["chatPage"] = "chatPage";
  PAGES["chatHistoryPage"] = "chatHistoryPage";
  PAGES["myPlaybooksPage"] = "myPlaybooksPage";
  PAGES["playbookPage"] = "playbookPage";
  PAGES["rulePage"] = "rulePage";
  PAGES["recentRunsPage"] = "recentRunsPage";
  PAGES["networkDiagnosticsPage"] = "networkDiagnosticsPage";
  PAGES["fallbackPage"] = "fallbackPage";
  return PAGES;
}({});
var PageContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var PageProvider = exports.PageProvider = function PageProvider(_ref) {
  var children = _ref.children;
  var initialPage = (0, _react.useMemo)(function () {
    var queryParams = new URLSearchParams(window.location.search);
    return queryParams.get("page") || PAGES.chatPage;
  }, []);
  var _useState = (0, _react.useState)(initialPage),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    pageParams = _useState4[0],
    setPageParams = _useState4[1];
  var showPage = (0, _react.useCallback)(function (pageName, params) {
    setCurrentPage(pageName);
    setPageParams(params || {});
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PageContext.Provider, {
    value: {
      currentPage: currentPage,
      pageParams: pageParams,
      showPage: showPage
    },
    "data-sentry-element": "PageContext.Provider",
    "data-sentry-component": "PageProvider",
    "data-sentry-source-file": "PageContext.tsx",
    children: children
  });
};
var usePage = exports.usePage = function usePage() {
  var context = (0, _react.useContext)(PageContext);
  if (!context) {
    throw new Error("usePage must be used within a PageProvider");
  }
  return context;
};
var _default = exports.default = PageContext;